module.exports = __webpack_public_path__ + "static/media/a15.069f6086.pdf";